import { render, staticRenderFns } from "./find_doc.vue?vue&type=template&id=0f8935ac&scoped=true&"
import script from "./find_doc.vue?vue&type=script&lang=js&"
export * from "./find_doc.vue?vue&type=script&lang=js&"
import style0 from "./find_doc.vue?vue&type=style&index=0&id=0f8935ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8935ac",
  null
  
)

export default component.exports